import { Link } from 'react-router-dom';

interface CalculatorMeta {
  slug: string;
  title: string;
  tagline: string;
  icon: string;
}

const ALL_CALCULATORS: CalculatorMeta[] = [
  {
    slug: 'missed-calls',
    title: 'Missed Call Revenue Loss',
    tagline: 'See the dollar value of every call your phone drops.',
    icon: 'ri-phone-off-line',
  },
  {
    slug: 'ai-receptionist-roi',
    title: 'AI Receptionist ROI',
    tagline: 'Payback period and ROI multiple for an AI front desk.',
    icon: 'ri-robot-2-line',
  },
  {
    slug: 'lead-value',
    title: 'Lead Value Calculator',
    tagline: 'Know what one qualified lead is actually worth.',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    slug: 'seo-traffic-value',
    title: 'Local SEO Traffic Value',
    tagline: 'Turn organic traffic into projected revenue.',
    icon: 'ri-search-line',
  },
  {
    slug: 'review-generation-roi',
    title: 'Review Generation ROI',
    tagline: 'Revenue lift from half a star more on Google.',
    icon: 'ri-star-smile-line',
  },
];

interface RelatedCalculatorsProps {
  excludeSlug: string;
}

export default function RelatedCalculators({ excludeSlug }: RelatedCalculatorsProps) {
  const items = ALL_CALCULATORS.filter((c) => c.slug !== excludeSlug);

  return (
    <section className="py-16 bg-navy-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-navy-900 text-3xl md:text-4xl font-display font-bold mb-3 text-center">
          More Free Calculators
        </h2>
        <p className="text-navy-600 text-center mb-10 text-base md:text-lg">
          Built for Florida business owners. Free forever. No signup required.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((c) => (
            <Link
              key={c.slug}
              to={`/calculator/${c.slug}`}
              className="fame-card p-6 hover:shadow-2xl transition-all border-l-4 border-teal-500 group"
            >
              <div className="w-12 h-12 bg-teal-50 rounded-lg flex items-center justify-center mb-4">
                <i className={`${c.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-navy-900 text-lg font-display font-bold mb-2">{c.title}</h3>
              <p className="text-navy-600 text-sm mb-4">{c.tagline}</p>
              <span className="text-teal-600 text-sm font-bold group-hover:underline">
                Open Calculator <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export { ALL_CALCULATORS };
